module.exports = __webpack_public_path__ + "img/content6.c1880720.png";